import { connect } from 'react-redux';
import actionCreator from '../../components/redux/action-creator';

import OffersPageComponent from './OffersPageComponent';

function mapStateToProps(state, props) {
    const { offersPage } = state;
    const {
        cardId,
        clientStateMinAmount = props.clientStateMinAmount,
        customizedOffer,
        fetching,
        getsQLDiscount = props.getsQLDiscount,
        getsRLReturningClientDiscount = props.getsRLReturningClientDiscount,
        hasError,
        isTeamMember = props.isTeamMember,
        getsCyberMondayDiscount = props.getsCyberMondayDiscount,
        autoPayDiscountConfig,
        maxOffer,
        minOffer,
        offers,
        user = props.user,
        requestedAmountAvailable
    } = offersPage;

    return {
        ...props,
        cardId,
        clientStateMinAmount,
        customizedOffer,
        fetching,
        getsQLDiscount,
        getsRLReturningClientDiscount,
        hasError,
        isTeamMember,
        getsCyberMondayDiscount,
        autoPayDiscountConfig,
        maxOffer,
        minOffer,
        offers,
        user,
        requestedAmountAvailable,
    };
}

const mapDispatchToProps = (dispatch, _ownProps) => ({
    fetchOffers: (params) => {
        // Access the current state using dispatch and getState
        dispatch((_, getState) => {
            const state = getState();
            // Check the condition in the state
            if (state && state.loan && state.loan.loanJson && state.loan.loanJson.loanId) {
                dispatch(actionCreator.fetchOffersAuthenticated(params, state.loan.loanJson.loanId));
            } else if (params && params.token) {
                dispatch(actionCreator.pollWithAppRouterToken(params.token));
            } else {
                dispatch(actionCreator.fetchOffers(params));
            }
        });
    },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(OffersPageComponent);